var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"mb-4"},[_c('h1',{staticClass:"display-2 font-weight-bold mb-3"},[_vm._v(" Email verification ")]),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }